// extracted by mini-css-extract-plugin
export default {"header":"Header_header__MY7fH","closeIcon":"Header_closeIcon__llbQ6","logo":"Header_logo__qeTuP"};